import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../models'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../util/functions'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {CellphoneBodyModel} from '../../../model/creationCellphones.model'
import {creationCellphoneSchema} from '../../../schema/creationCellphone'
import {CREATION_CELLPHONES_SERVICES} from '../../../services'
import {funcDelete} from '../../../util/function'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'

const CreationCellphonesPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLimpieza()
  const [loading, setLoading] = useState(false)
  const methods = useForm<CellphoneBodyModel>({
    resolver: yupResolver(creationCellphoneSchema),
  })

  const handleDelete = async () => {
    await funcDelete(
      CREATION_CELLPHONES_SERVICES.deleteCellphone,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: CellphoneBodyModel) => {
    try {
      setLoading(true)
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await CREATION_CELLPHONES_SERVICES.createCellphone({...data})
        : await CREATION_CELLPHONES_SERVICES.editCellphone({...data, Id: currentTabItem.idToEdit})

      if (!response.data.error) {
        methods.reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabLimpiezaModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-creation-of-cellphones',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.message ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
      setLoading(false)
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-creation-of-cellphones'
          textComponentGo='form-creation-of-cellphones'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-limpieza-header-${currentTabItem.id}`}
              id={`panel-limpieza-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-limpieza-detail-${currentTabItem.id}`}
                    id={`panel-limpieza-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default CreationCellphonesPageWrapper
